// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__En90J","filesListContainer":"PosDisputesFiles_filesListContainer__tIWbc","filesButton":"PosDisputesFiles_filesButton__3PpeB"};